import { render, staticRenderFns } from "./LayoutTypeSelect.vue?vue&type=template&id=f8dd729a&scoped=true&"
import script from "./LayoutTypeSelect.vue?vue&type=script&lang=js&"
export * from "./LayoutTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./LayoutTypeSelect.vue?vue&type=style&index=0&id=f8dd729a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dd729a",
  null
  
)

export default component.exports